'use strict';

$(document).ready(function () {
    // cancel Tour listener
    $('#tour-cancel').on('click', function (e) {
        e.preventDefault();
        if (confirm('Are you sure to cancel tour reservation?')) {
            $('.loader-wrapper ').show();
            $.ajax({
                method: 'POST',
                url: window.location.origin + '/api/v1/tasting/tour-cancel',
                data: { code: $(e.currentTarget).data('code'), email: $(e.currentTarget).data('email') },
                success: function success(data) {
                    var elm = $(e.currentTarget).parent().next('p');
                    elm.html(elm.data('cancelTxt'));
                    $(e.currentTarget).parent().hide();
                    $('.loader-wrapper ').hide();
                },
                error: function error(data) {
                    $('.loader-wrapper ').hide();
                }
            });
        }
    });
});